import DebouncedTextField from "@/components/DebouncedTextField";
import Text from "@/components/Text";
import SectionAccordion from "./SectionAccordion";
import CheckboxRowTextGroup, { RowDef } from "./CheckboxRowTextGroup";
import {
  FREE_TEXT_LABEL,
  FREE_TEXT_MAX_ROWS,
  FREE_TEXT_MIN_ROWS,
  FREE_TEXT_PLACEHOLDER,
} from "../readmission-f2f-constant";
import { RowTextValue, SummaryLine } from "../readmission-f2f-types";
import {
  buildFreeTextEntry,
  buildRowTextEntries,
} from "../readmission-f2f-summary-utils";

export interface RowTextSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  rows: RowDef[];
  value: RowTextValue;
  onChange: (value: RowTextValue) => void;
  columns?: number;
  exclusive?: Record<string, string[]>;
  freeText?: string;
  onFreeTextChange?: (value: string) => void;
  hint?: string;
  showCurrentVisit?: boolean;
}

const RowTextSection = ({
  title,
  expanded,
  onToggle,
  rows,
  value,
  onChange,
  columns = 1,
  exclusive,
  freeText,
  onFreeTextChange,
  hint,
  showCurrentVisit,
}: RowTextSectionProps) => {
  const summaryLines: SummaryLine[] = [
    ...buildRowTextEntries(value),
    ...buildFreeTextEntry(freeText),
  ];

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      summaryLines={summaryLines}
      showCurrentVisit={showCurrentVisit}
      unmountWhenCollapsed
    >
      <CheckboxRowTextGroup
        rows={rows}
        value={value}
        onChange={onChange}
        columns={columns}
        exclusive={exclusive}
      />
      {hint && (
        <Text size={12} c="text.secondary">
          {hint}
        </Text>
      )}
      {onFreeTextChange && (
        <>
          <Text fontWeight="bold">{FREE_TEXT_LABEL}</Text>
          <DebouncedTextField
            size="small"
            fullWidth
            multiline
            minRows={FREE_TEXT_MIN_ROWS}
            maxRows={FREE_TEXT_MAX_ROWS}
            placeholder={FREE_TEXT_PLACEHOLDER}
            value={freeText ?? ""}
            onChange={onFreeTextChange}
            inputProps={{ "aria-label": `${title} ${FREE_TEXT_LABEL}` }}
          />
        </>
      )}
    </SectionAccordion>
  );
};

export default RowTextSection;
